import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
var FILTERS = "filters";
export function getFilters() {
  return JSON.parse(localStorage.getItem(FILTERS));
}
export function setFilters(lambda) {
  var state = lambda(getFilters());
  localStorage.setItem(FILTERS, JSON.stringify(state));
}
export function setGlobalFilters(value) {
  localStorage.setItem(FILTERS, JSON.stringify(value));
}
export function clearAllFilters() {
  localStorage.removeItem(FILTERS);
}